const styles = () => ({
  langSelectorText: {
    margin: "0",
    position: "relative",
    transform: "translateX(0px)",
    color: "inherit",
    opacity: "1",
    whiteSpace: "nowrap",
    display: "inline-block",
    transition: "transform 300ms ease 0s, opacity 300ms ease 0s",
    fontSize: "15px",
    paddingLeft: "15px",
  },

  firstLanguageBorder: {
    borderTop: "1px solid black",
    borderBottom: "1px solid black",
    paddingTop: "10px",
    paddingBottom: "10px",
  },

  restOfLanguagesBorder: {
    borderBottom: "1px solid black",
    paddingTop: "10px",
    paddingBottom: "10px",
  },

  card: {
    padding: "30px 30px 0px 40px",
  },

  buttonPaddingTop: {
    paddingTop: "15px",
  },

  rightAlign: {
    float: "right",
  },

  scrollbar: {
    overflowX: "hidden !important",
    width: "100%",
    height: "100%",
  },

  keyTypography: {
    fontWeight: "bold",
    fontSize: "14px",
  },

  valueTypography: {
    fontStyle: "italic",
    fontSize: "14px",
  },
});

export default styles;
